import { useCallback, useState } from "react";

export function useDrawerExpandedInConversation(conversationId: string, isDrawerShown: boolean): [boolean, (isExpanded: boolean) => void] {
  const [conversationIdWithExpandedDrawer, setConversationIdWithExpandedDrawer] = useState<string | null>(null);
  if (!isDrawerShown && conversationIdWithExpandedDrawer !== null) setConversationIdWithExpandedDrawer(null);
  const setIsDrawerExpanded = useCallback((isExpanded: boolean) => {
    setConversationIdWithExpandedDrawer(isExpanded ? conversationId : null);
  }, [conversationId]);
  return [isDrawerShown && conversationIdWithExpandedDrawer === conversationId, setIsDrawerExpanded];
}
